import { V3Record } from 'data/helpers/V3Record.js'

export const Club = V3Record('club', {
  name: null,
  userId: null,
  appDetails: null,
  logo: null,
  cover: null,
  subscriptionId: null,
  createdAt: null,
  inviteOnly: null,
  messageEnabled: null,
  calendarEnabled: null,
  memberMessagesEnabled: null,
  requireNameAndEmail: null,
  organizationType: null,
  contactName: null,
  contactEmail: null,
  richDescription: null,
  externalUrls: null,
  ambassadorId: null,
  administrativeArea: null
})
